import { BackendResponseFormat } from "../utils/fetch";
import { BackendError } from "./BackendError";

export class UnauthorizedError extends BackendError {
  constructor(responseBody: BackendResponseFormat<unknown> | string) {
    super(401, responseBody);
    this.name = "UnauthorizedError";
  }
}
